import { settingsCertificationEn } from "./settings";

const pagesCertificationEn = {
  add: {
    form: {
      progressbar: {
        total: "Total",
        mustItem: "Must Item",
        left: "{{value}} left",
        filled: "filled",
        modeSetting: "Mode Settings",
        mustItemOnly: "Must item only",
      },
      navigation: {
        title: "Add certification",
        steps: {
          common: {
            submitButtonLabel: "Add Certification",
          },
          baseCertificationIdInformation: {
            title: "Certification ID Information",
          },
          baseCertificationNameAndDisplay: {
            title: "Certification Name and Display",
          },
          baseCertificationClassification: {
            title: "Certification Classification",
          },
          baseCertificationAdministrativeAuthority: {
            title: "Administrative Authority",
          },
          baseCertificationValidity: {
            title: "Validity and Renewal",
          },
          baseCertificationSubjectInformation: {
            title: "Subject Information",
          },
          baseCertificationLawsAndRisks: {
            title: "Laws and Risks",
          },
          baseCertificationOperationAndStatus: {
            title: "Operation and Status",
          },
          specialtyCertificationIdInformation: {
            title: "Specialty Certification ID Information",
          },
          specialtyRelatedBasicCertification: {
            title: "Related Basic Certification",
          },
          specialtyNameAndDisplay: {
            title: "Name and Display",
          },
          specialtyClassificationAndLevel: {
            title: "Classification and Level",
          },
          specialtyIssuingOrganization: {
            title: "Issuing Organization",
          },
          specialtyValidityAndRenewalRules: {
            title: "Validity and Renewal Rules",
          },
          specialtyScope: {
            title: "Scope",
          },
          specialtyPrerequisites: {
            title: "Prerequisites",
          },
          specialtyOperationAndStatus: {
            title: "Operation and Status",
          },
          handlingCertificationIdInformation: {
            title: "Handling ID Information",
          },
          handlingNameAndDisplay: {
            title: "Name and Display",
          },
          handlingRelatedBasicAndSpecialtyCertification: {
            title: "Related Basic and Specialty Certification",
          },
          handlingIssuingOrganization: {
            title: "Issuing Organization",
          },
          handlingValidityAndRenewalRules: {
            title: "Validity and Renewal Rules",
          },
          handlingScope: {
            title: "Scope",
          },
          handlingRisksAndRestrictions: {
            title: "Risks and Restrictions",
          },
          handlingOperationAndStatus: {
            title: "Operation and Status",
          },
          certificationInformation: {
            title: "Certification information",
          },
          cards: {
            idInformation: {
              title: "Certification ID Information",
              certificationId: "Certification ID",
              certificationName: "Certification Name",
              certificationParty: "Certification Party",
              certificationHolder: "Certification Holder",
              certificationHolderPlaceholder: "Select Certification Holder",
            },
            validityPeriod: {
              title: "Validity Period",
              effectiveDate: "Effective Date",
              expirationDate: "Expiration Date (Optional)",
              renewalDate: "Renewal Date (Optional)",
            },
          },
        },
      },
      completed: {
        result: "Result",
        message: "Certification added.",
        goToCertification: "Go to certification",
        completedBy: "Completed by:",
        continueAdding: "Continue adding another certification",
        goToBaseCertification: "Go to base certification",
        goToSpecialtyCertification: "Go to specialty certification",
        goToHandlingCertification: "Go to handling certification",
        goToList: "Go to list",
        BASE: {
          message: "Base Certification added.",
        },
        SPECIALTY: {
          message: "Specialty Certification added.",
        },
        HANDLING: {
          message: "Handling Certification added.",
        },
      },
      fields: {
        baseCertificationIdInformation: {
          certificationCode: {
            label: "Certification Code",
            placeholder: "Enter certification code",
          },
        },
        baseCertificationNameAndDisplay: {
          certificationName: {
            label: "Certification name",
            placeholder: "Enter certification name",
          },
          certificationNameEn: {
            label: "Certification name (English)",
            placeholder: "Enter certification name (English)",
          },
          certificationNameShort: {
            label: "Certification name short",
            placeholder: "Enter certification name short",
          },
          displayOrder: {
            label: "Display order",
            placeholder: "Enter display order",
          },
        },
        baseCertificationClassification: {
          certificationType: {
            label: "Certification type",
            placeholder: "Select certification type",
            options: {
              NATIONAL: "National",
              PUBLIC: "Public",
              PRIVATE: "Private",
            },
          },
          industryCategory: {
            label: "Industry category",
            placeholder: "Select industry category",
            options: {
              HEALTHCARE: "Healthcare",
              INSURANCE: "Insurance",
              FINANCE: "Finance",
            },
          },
          domain: {
            label: "Domain",
            placeholder: "Enter domain",
          },
        },
        baseCertificationAdministrativeAuthority: {
          regulatingAuthorityName: {
            label: "Regulating authority name",
            placeholder: "Enter regulating authority name",
          },
          issuingOrganizationId: {
            label: "Issuing organization ID",
            placeholder: "Enter issuing organization ID",
          },
        },
        baseCertificationValidity: {
          defaultValidPeriodYears: {
            label: "Default valid period (years)",
            placeholder: "Enter default valid period",
          },
          renewalUnit: {
            label: "Renewal unit",
            placeholder: "Select renewal unit",
            options: {
              YEAR: "Year",
              MONTH: "Month",
            },
          },
          renewalRequirementType: {
            label: "Renewal requirement type",
            placeholder: "Enter renewal requirement type",
          },
          renewalRequirementDescription: {
            label: "Renewal requirement description",
            placeholder: "Enter renewal requirement description",
          },
          renewalDeadlineType: {
            label: "Renewal deadline type",
            placeholder: "Select renewal deadline type",
            options: {
              EXPIRATION_DATE: "Expiration date",
              YEAR_END: "Year end",
            },
          },
        },
        baseCertificationSubjectInformation: {
          targetJobType: {
            label: "Target job type",
            placeholder: "Enter target job type",
          },
          prerequisiteSummary: {
            label: "Prerequisite summary",
            placeholder: "Enter prerequisite summary",
          },
        },
        baseCertificationLawsAndRisks: {
          legalBasis: {
            label: "Legal basis",
            placeholder: "Enter legal basis",
          },
          complianceRiskLevel: {
            label: "Compliance risk level",
            placeholder: "Select compliance risk level",
            options: {
              LOW: "Low",
              MEDIUM: "Medium",
              HIGH: "High",
            },
          },
        },
        baseCertificationOperationAndStatus: {
          effectivePeriod: {
            label: "Effective Period",
            placeholder: "Select effective period",
            checkboxLabel: "Specify end date",
          },
          effectiveFrom: {
            label: "Effective from",
            placeholder: "Select effective from date",
          },
          effectiveTo: {
            label: "Effective to",
            placeholder: "Select effective to date",
          },
          archivedDate: {
            label: "Archived date",
            placeholder: "Select archived date",
          },
          remarks: {
            label: "Remarks",
            placeholder: "Enter remarks",
          },
        },
        specialtyCertificationIdInformation: {
          specialtyCertificationCode: {
            label: "Specialty Certification Code",
            placeholder: "Enter specialty certification code",
          },
        },
        specialtyRelatedBasicCertification: {
          baseCertificationIds: {
            add: "Add Related Base Certification",
            label: "Base Certification ID",
            placeholder: "Enter base certification ID",
          },
          requiredBaseCertificationLevelStatus: {
            label: "Required Base Certification Level/Status",
            placeholder: "Enter required base certification level/status",
          },
        },
        specialtyNameAndDisplay: {
          specialtyName: {
            label: "Specialty Name (JP)",
            placeholder: "Enter specialty name",
          },
          specialtyNameEn: {
            label: "Specialty Name (EN)",
            placeholder: "Enter specialty name in English",
          },
          specialtyNameShort: {
            label: "Short Name",
            placeholder: "Enter short name",
          },
          displayOrder: {
            label: "Display Order",
            placeholder: "Enter display order",
          },
        },
        specialtyClassificationAndLevel: {
          specialtyCategory: {
            label: "Specialty Category",
            placeholder: "Enter specialty category",
          },
          specialtyLevel: {
            label: "Specialty Level",
            placeholder: "Enter specialty level",
          },
          specialtyDescription: {
            label: "Specialty Description",
            placeholder: "Enter specialty description",
          },
        },
        specialtyIssuingOrganization: {
          issuingOrganizationId: {
            label: "Issuing Organization ID",
            placeholder: "Enter issuing organization ID",
          },
          issuingOrganizationName: {
            label: "Issuing Organization Name",
            placeholder: "Enter issuing organization name",
          },
        },
        specialtyValidityAndRenewalRules: {
          defaultValidPeriodYears: {
            label: "Default Valid Period (Years)",
            placeholder: "Enter default valid period",
          },
          renewalUnit: {
            label: "Renewal Unit",
            placeholder: "Select renewal unit",
          },
          renewalRequirementType: {
            label: "Renewal Requirement Type",
            placeholder: "Enter renewal requirement type",
          },
          renewalRequirementDescription: {
            label: "Renewal Requirement Description",
            placeholder: "Enter renewal requirement description",
          },
          reacquisitionRule: {
            label: "Reacquisition Rule",
            placeholder: "Enter reacquisition rule",
          },
        },
        specialtyScope: {
          country: {
            label: "Country",
            placeholder: "Enter country",
          },
          region: {
            label: "Region",
            placeholder: "Enter region",
          },
          restrictedOrganizationFlag: {
            label: "Restricted Organization Flag",
            checkboxLabel: "Restricted to specific organizations",
          },
        },
        specialtyPrerequisites: {
          requiredExperienceYears: {
            label: "Required Experience Years",
            placeholder: "Enter required experience years",
          },
          requiredCaseCount: {
            label: "Required Case Count",
            placeholder: "Enter required case count",
          },
          requiredOtherCertification: {
            label: "Required Other Certification",
            placeholder: "Enter required other certification",
            add: "Add Required Other Certification",
          },
        },
        specialtyOperationAndStatus: {
          effectivePeriod: {
            label: "Effective Period",
            placeholder: "Select effective period",
            checkboxLabel: "Specify end date",
          },
          effectiveFrom: {
            label: "Effective From",
            placeholder: "Select effective from date",
          },
          effectiveTo: {
            label: "Effective To",
            placeholder: "Select effective to date",
          },
          archivedFlag: {
            label: "Archived Flag",
            checkboxLabel: "This certification is archived",
          },
          archivedDate: {
            label: "Archived Date",
            placeholder: "Select archived date",
          },
          remarks: {
            label: "Remarks",
            placeholder: "Enter remarks",
          },
        },
        handlingCertificationIdInformation: {
          handlingCertificationCode: {
            label: "Handling Certification Code",
            placeholder: "Enter handling certification code",
          },
        },
        handlingNameAndDisplay: {
          handlingName: {
            label: "Handling Certification Name (JP)",
            placeholder: "Enter handling certification name",
          },
          handlingNameEn: {
            label: "Handling Certification Name (EN)",
            placeholder: "Enter handling certification name in English",
          },
          shortName: {
            label: "Short Name",
            placeholder: "Enter short name",
          },
          displayOrder: {
            label: "Display Order",
            placeholder: "Enter display order",
          },
        },
        handlingRelatedBasicAndSpecialtyCertification: {
          baseCertificationIds: {
            add: "Add Related Base Certification",
            label: "Base Certification IDs",
            placeholder: "Select base certifications",
          },
          specialtyCertificationIds: {
            add: "Add Related Specialty Certification",
            label: "Specialty Certification IDs",
            placeholder: "Select specialty certifications",
          },
        },
        handlingIssuingOrganization: {
          issuingOrganizationId: {
            label: "Issuing Organization ID",
            placeholder: "Select issuing organization",
          },
        },
        handlingValidityAndRenewalRules: {
          defaultValidPeriodYears: {
            label: "Default Valid Period (Years)",
            placeholder: "Enter default valid period",
          },
          renewalRequirementDescription: {
            label: "Renewal Requirement Description",
            placeholder: "Enter renewal requirement description",
          },
          reCertificationRules: {
            label: "Re-certification Rules",
            placeholder: "Enter re-certification rules",
          },
        },
        handlingScope: {
          country: {
            label: "Country",
            placeholder: "Enter country",
          },
          region: {
            label: "Region",
            placeholder: "Enter region",
          },
          channel: {
            label: "Channel",
            placeholder: "Enter channel",
          },
          organizationScope: {
            label: "Organization Scope",
            placeholder: "Enter organization scope",
          },
        },
        handlingRisksAndRestrictions: {
          handlingRestriction: {
            label: "Handling Restriction",
            placeholder: "Enter handling restriction",
          },
          handlerAttributeRestriction: {
            label: "Handler Attribute Restriction",
            placeholder: "Enter handler attribute restriction",
          },
        },
        handlingOperationAndStatus: {
          effectivePeriod: {
            label: "Effective Period",
            placeholder: "Select effective period",
            checkboxLabel: "Specify end date",
          },
          effectiveFrom: {
            label: "Effective From",
            placeholder: "Select effective from date",
          },
          effectiveTo: {
            label: "Effective To",
            placeholder: "Select effective to date",
          },
          archivedFlag: {
            label: "Archived Flag",
            checkboxLabel: "This certification is archived",
          },
          archivedDate: {
            label: "Archived Date",
            placeholder: "Select archived date",
          },
          remarks: {
            label: "Remarks",
            placeholder: "Enter remarks",
          },
        },
        certificationName: {
          label: "Certification name",
        },
        certificationType: {
          label: "Certification type",
        },
      },
    },
    intro: {
      header: {
        headerTitle: "Add Certification Data to your Registry",
      },
      body: {
        selectCertification: "Select the certification:",
        fillOutDetails: "Fill out the details",
        itemCard: {
          requiredDetails: "Required details:",
        },
      },
      options: {
        description: "Or you might want to...",
        addCertificationHolder: "Add person certification data",
      },
    },
  },
  list: {
    pageTitle: "Certifications",
    addCertification: "Add Certification",
    filterPlaceholder: "Search by certification name...",
    tabs: {
      all: "All",
      archived: "Archived",
    },
    actions: {
      export: "Export",
      share: "Share",
    },
  },
  certificationKind: {
    base: "Base certification",
    specialty: "Specialty certification",
    handling: "Handling certification",
  },
  detail: {
    tabs: {
      detail: "Detail",
      specialtyCertifications: "Specialty certifications",
      handlingCertifications: "Handling certifications",
      certificationHolders: "People",
    },
    body: {
      noDataMessage: "No data available in this section.",
      errors: {
        dataLoadFailed: "Failed to load data",
        unknownError: "An unknown error occurred",
        certificationNotFound: "Certification details not found",
        certificationIdLabel: "Certification ID: {{id}}",
      },
    },
  },
  certificationStatus: {
    EFFECTIVE: "Effective",
    NOT_EFFECTIVE: "Not Effective",
    ARCHIVED: "Archived",
  },
  certificationHolderStatus: {
    ACTIVE: "Active",
    APPLYING: "Applying",
    EXPIRED: "Expired",
    SUSPENDED: "Suspended",
    REVOKED: "Revoked",
  },
  specialty: {
    list: {
      pageTitle: "Specialty Certifications",
      filterPlaceholder: "Search by specialty certification name...",
      addSpecialtyCertification: "Add Specialty Certification",
      tabs: {
        effective: "Effective",
        notEffective: "Not Effective",
        archived: "Archived",
      },
    },
    detail: {
      tabs: {
        detail: "Detail",
        handlingCertifications: "Handling Certifications",
        certificationHolders: "Certification Holders",
      },
      body: {
        noDataMessage: "No data available in this section.",
        errors: {
          dataLoadFailed: "Failed to load data",
          unknownError: "An unknown error occurred",
          specialtyCertificationNotFound:
            "Specialty certification details not found",
          specialtyCertificationIdLabel: "Specialty Certification ID: {{id}}",
        },
      },
    },
  },
  handling: {
    list: {
      pageTitle: "Handling Certifications",
      filterPlaceholder: "Search by handling certification name...",
      addHandlingCertification: "Add Handling Certification",
      tabs: {
        effective: "Effective",
        notEffective: "Not Effective",
        archived: "Archived",
      },
    },
    detail: {
      tabs: {
        detail: "Detail",
        certificationHolders: "Certification Holders",
      },
      body: {
        noDataMessage: "No data available in this section.",
        errors: {
          dataLoadFailed: "Failed to load data",
          unknownError: "An unknown error occurred",
          handlingCertificationNotFound:
            "Handling certification details not found",
          handlingCertificationIdLabel: "Handling Certification ID: {{id}}",
        },
      },
    },
  },
  certificationHolder: {
    list: {
      pageTitle: "Certification Holders",
      filterPlaceholder: "Search by name or number...",
      addCertificationHolder: "Add certification holder",
    },
  },
  validation: {
    required: "{{field}} is required",
  },
  tabs: {
    detail: "Detail",
  },
  errors: {
    loadingFailed: "Failed to load data",
    unknownError: "An unknown error occurred",
  },
  settings: settingsCertificationEn,
};

export default pagesCertificationEn;
